import {Component, OnInit} from '@angular/core';
import {DialogComponent, DialogService} from 'ng2-bootstrap-modal';

export interface Model {
  title: string;
  data: string;
}

@Component({
  selector: 'app-column-chart',
  templateUrl: './column-chart.component.html',
  styleUrls: ['./column-chart.component.css', '../../myreports.component.css']
})
export class ColumnChartComponent extends DialogComponent<Model, any> implements OnInit {
  chartError = false;
  data: any;
  public options: any = {
    height: $(window).height() * 0.79,
    titlePosition: 'out',
    chartArea: {top: 30},
    legend: {position: 'none'},
    intervals: {
      barWidth: 0.25,
      boxWidth: 1,
      lineWidth: 2,
      style: 'bars'
    },
    interval: {
      max: {
        style: 'bars',
        fillOpacity: 1,
        color: 'black'
      },
      min: {
        style: 'bars',
        fillOpacity: 1,
        color: 'black'
      }
    },
    vAxis: {minValue: 0}
  };


  constructor(dialogService: DialogService) {
    super(dialogService);
  }

  ngOnInit() {
    document.getElementsByTagName('body')[0].classList.add('modal-open');
  }

}



// WEBPACK FOOTER //
// C:/Work/Projects/OnlineParser/web2-ui/src/app/reports/myReports/zoomView/column-chart/column-chart.component.ts